import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { ImageService } from '../../services/image.service';
import { ThemeService } from '../../services/theme.service';
import { AssetPipe } from "../../pipes/asset.pipe";
import { JssContextService } from '../../jss-context.service';
import { Subscription } from 'rxjs';
import { TwoLinkModalComponent } from '../two-link-modal/two-link-modal.component';

@Component({
  selector: 'app-hero-campaign',
  templateUrl: './hero-campaign.component.html'
})
export class HeroCampaignComponent implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering;
  @Input() data: any;
  @ViewChild(TwoLinkModalComponent) twoLinkModal: TwoLinkModalComponent;

  public fields: any;
  public energySubscription: Subscription;
  public image: { src: string; alt: string };
  loadedImage: HTMLImageElement;
  energySaveMode: boolean;
  public contextSubscription: Subscription;
  language: string;

  constructor(private imageService: ImageService, public jssContext: JssContextService, private themeService: ThemeService) { }

  ngOnInit() {
    this.contextSubscription = this.jssContext.state.subscribe((newState) => {
      this.language = newState.language
    });
    this.fields = this.rendering.fields as any;
    

    this.energySubscription = this.themeService.isEnegySaveModeEnabled().subscribe((energySave) => {
      this.energySaveMode = energySave;
      if (this.fields?.Image?.value?.src){
        this.image = {
          src: new AssetPipe().transform('images/default-image.png'),
          alt: ''
        };
        const img = this.imageService.getImage(this.fields);
        this.loadedImage = new Image();
        this.loadedImage.src = img.src;
        this.loadedImage.onload = () => {
          this.image = img;
        };
      }
    });
  }

  ngOnDestroy(): void {
    if (this.energySubscription){
      this.energySubscription.unsubscribe();
    }
    if (this.contextSubscription) {
      this.contextSubscription.unsubscribe();
    }
  }
  
  openPopup(event: Event): void {
    event.preventDefault();
    this.twoLinkModal?.openModal();
  }
}
